import axios from "axios";
import { EmployeeID, CompanyID } from "configs/AppConfig";
import { message } from "antd";

let EmployeeService = {};

EmployeeService.getEmployees = async function (showAll) {
  try {
    const response = await axios({
      url: `/EmployeeService.svc/GetAllEmployee`,
      params: {
        EmployeeID: EmployeeID,
        CompanyID: CompanyID,
        ShowAll: showAll ? true : false,
      },
    });

    const employees = response.data.Data;
    return employees;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    return null;
  }
};
EmployeeService.getEmployeesname = async function (showAll) {
  try {
    const response = await axios({
      url: `/EmployeeService.svc/GetAllEmployeeName`,
      params: {
        EmployeeID: EmployeeID,
        CompanyID: CompanyID,
        ShowAll: showAll ? true : false,
      },
    });

    const employees = response.data.Data;
    return employees;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    return null;
  }
};

EmployeeService.uploadEmployees = async function (employeeData) {
  try {
    const Employees = employeeData;
    const response = await axios({
      method: "post",
      url: `/EmployeeService.svc/PostEmployeeBatch`,
      params: {
        EmployeeID: EmployeeID,
      },
      data: Employees,
    });
    var errorCodes = [];

    // response.data.Data.forEach((element) => {
    //   element.Status !== "1" &&
    //     errorCodes.push({
    //       EmployeeCode: element.EmployeeCode,
    //       Message: element.Message,
    //     });
    // });

    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);
    // console.log(response.data)
    return response;
  } catch (error) {
    // message.warning(error.response.Data);
    // const status = error.response.status;
    // AuthService.statusHandler(status)
    return null;
  }
};

EmployeeService.ActivateEmployees = async function (
  EmployeeIds,
  label,
  objectActiveDeactive,
) {
  try {
    const response = await axios({
      method: "post",
      url: `/EmployeeService.svc/admin/UpdateEmployeeActiveStatus`,
      headers: {
        EmployeeID: EmployeeID,
      },
      data: objectActiveDeactive,
    });

    if (response.data.Status === 1) {
      if (label == "Active") {
        if (EmployeeIds.length > 1) {
          message.success("Employees Activated");
        } else {
          message.success("User Activated");
        }
      } else if (label == "DeActive") {
        // message.success(
        //   EmployeeIds.length > 1
        //     ? "Employees De-activated"
        //     : "User De-activated"
        // );
        if (EmployeeIds.length > 1) {
          message.success("Employees De-activated");
        } else {
          message.success('"User De-activated"');
        }
      }
    } else {
      message.warning(response.data.Message);
    }
  } catch (error) {
    console.log(error);
    message.warning(error);
    return null;
  }
};
// employees user delete  and group employee delete...
EmployeeService.DeleteEmployees = async function (
  EmployeeIds,
  objectActiveDeactive,
) {
  try {
    const response = await axios({
      method: "post",
      url: `/EmployeeService.svc/admin/DeleteEmployees`,
      headers: {
        EmployeeID: EmployeeID,
      },
      data: objectActiveDeactive,
    });

    if (response.data.Status === 1) {
      // message.success(
      //   EmployeeIds.length > 1 ? "Employees Deleted" : "User Deleted"
      // );
      if (EmployeeID.length > 1) {
        message.success("Employees Deleted");
      } else {
        message.success("User Deleted");
      }
    } else {
      message.warning(response.data.Message);
    }
  } catch (error) {
    message.warning(error);
    return null;
  }
};

EmployeeService.updateEmployee = async function (empObjectData) {
  try {
    const Employees = empObjectData;
    const response = await axios({
      method: "post",
      url: `/EmployeeService.svc/UpdateEmployeeBatch`,
      params: {
        EmployeeID: EmployeeID,
      },
      data: Employees,
    });

    var errorCodes = [];

    // response.data.Data.forEach((element) => {
    //   element.Status !== "1" &&
    //     errorCodes.push({
    //       EmployeeCode: element.EmployeeCode,
    //       Message: element.Message,
    //     });
    // });

    // if (errorCodes.length === 0) {
    //   message.success("Employees Updated");
    // } else {
    //   message.error(
    //     `${errorCodes.map((element) => {
    //       return element.EmployeeCode + ": " + element.Message;
    //     })} `,
    //     15
    //   );
    // }

    response.status !== 200 &&
      message.warning(`Request failed with a status code ${response.status}`);

    return response;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    return null;
  }
};

EmployeeService.getEditEmployeeById = async function (employeeid) {
  try {
    const response = await axios({
      url: `/EmployeeService.svc/GetEmployeeById`,
      params: {
        EmployeeID: employeeid,
      },
      // headers: Headers,
    });
    const getEditEmp = response.data.Data;
    return getEditEmp;
  } catch (error) {
    console.log(error);
    message.warning(error);
    const status = error.response.status;
    // AuthService.statusHandler(status)
    return null;
  }
};

EmployeeService.GetFilterListData = async function (condition) {
  try {
    const response = await axios({
      url: `/EmployeeService.svc/admin/GetFilterListData?isForFilter=${condition}`,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.GetEmployeeFilteredData = async function (data) {
  try {
    const response = await axios({
      method: "POST",
      url: `/EmployeeService.svc/admin/GetEmployeeFilteredData`,
      data: data,
    });
    return response;
  } catch (error) {
    message.warning(error);
    return null;
  }
};

EmployeeService.storeList = async function (condition) {
  try {
    const response = await axios({
      url: `/EmployeeService.svc//admin/Get/FilterListData/store?isForFilter=${condition}`,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.PostEmployeeCodeBulkEdit = async function (
  EmployeeID,
  payload,
) {
  try {
    const response = await axios({
      method: "POST",
      url: `/EmployeeService.svc/admin/update/employeecode`,
      headers: {
        EmployeeID: EmployeeID,
      },
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.GetAllDepartments = async function (EmployeeID) {
  try {
    const response = await axios({
      method: "GET",
      url: `DepartmentService.svc/GetAllDepartment`,
      headers: {
        EmployeeID: EmployeeID,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.GetAllDesignations = async function (EmployeeID) {
  try {
    const response = await axios({
      method: "GET",
      url: `/DesignationService.svc/GetAllDesignation?EmployeeID=${EmployeeID}`,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.AddDesignation = async function (EmployeeID, payload) {
  try {
    const response = await axios({
      method: "POST",
      url: `/DesignationService.svc/AddDesignation`,
      headers: { EmployeeID: EmployeeID },
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.AddDepartment = async function (EmployeeID, payload) {
  try {
    const response = await axios({
      method: "POST",
      url: `/DepartmentService.svc/AddDepartment`,
      headers: { EmployeeID: EmployeeID },
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.DeleteDesignation = async function (EmployeeID, payload) {
  try {
    const response = await axios({
      method: "DELETE",
      url: `/DesignationService.svc/DeleteDesignationById?DesignationID=${payload}`,
      headers: { EmployeeID: EmployeeID },
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.DeleteDepartment = async function (EmployeeID, payload) {
  try {
    const response = await axios({
      method: "DELETE",
      url: `/DepartmentService.svc/DeleteDepartmentById?DepartmentId=${payload}`,
      headers: { EmployeeID: EmployeeID },
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.UpdateDepartment = async function (EmployeeID, payload) {
  try {
    const response = await axios({
      method: "POST",
      url: `/DepartmentService.svc/UpdateDepartment`,
      headers: { EmployeeID: EmployeeID },
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.UpdateDesignation = async function (EmployeeID, payload) {
  try {
    const response = await axios({
      method: "POST",
      url: `/DesignationService.svc/UpdateDesignation`,
      headers: { EmployeeID: EmployeeID },
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};
EmployeeService.AddLocation = async function (EmployeeID, payload) {
  try {
    const response = await axios({
      method: "POST",
      url: `/EmployeeService.svc/AddLocation`,
      headers: { EmployeeID: EmployeeID },
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};
EmployeeService.UpdateLocation = async function (EmployeeID, payload) {
  try {
    const response = await axios({
      method: "POST",
      url: `/EmployeeService.svc/UpdateLocation`,
      headers: { EmployeeID: EmployeeID },
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};
EmployeeService.DeleteLocation = async function (EmployeeID, payload) {
  try {
    const response = await axios({
      method: "POST",
      url: `/EmployeeService.svc/DeleteLocationById`,
      headers: { EmployeeID: EmployeeID },
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.GetAllLocation = async function (EmployeeID) {
  try {
    const response = await axios({
      method: "GET",
      url: `/EmployeeService.svc/GetAllLocation`,
      headers: {
        EmployeeID: EmployeeID,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.GetLocationById = async function (EmployeeID, locationId) {
  try {
    const response = await axios({
      method: "GET",
      url: `/EmployeeService.svc/GetLocationById?LocationID=${locationId}`,
      headers: { EmployeeID: EmployeeID },
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.GetDesignationById = async function (EmployeeID, destId) {
  try {
    const response = await axios({
      method: "GET",
      url: `/DesignationService.svc/GetDesignationById?DesignationID=${destId}`,
      headers: { EmployeeID: EmployeeID },
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};
EmployeeService.GetDepartmentById = async function (EmployeeID, deptId) {
  try {
    const response = await axios({
      method: "GET",
      url: `/DepartmentService.svc/GetDepartmentById?DepartmentID=${deptId}`,
      headers: { EmployeeID: EmployeeID },
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};
EmployeeService.GetAllState = async function (EmployeeID) {
  try {
    const response = await axios({
      method: "GET",
      url: `/StateService.svc/GetAllState?EmployeeID=${EmployeeID}`,
      headers: { EmployeeID: EmployeeID },
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.GetAllCity = async function (StateID) {
  try {
    const queryParam = StateID
      ? `StateID=${StateID}`
      : `EmployeeID=${EmployeeID}`;
    const response = await axios({
      method: "GET",
      url: `/CityService.svc/GetAllCity?${queryParam}`,
      headers: { EmployeeID: EmployeeID },
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.GetSubsidisedFoodReport = async function (
  filterData,
  Month,
  Year,
) {
  try {
    const response = await axios({
      method: "POST",
      url: `/EmployeeService.svc/admin/GetSubsidisedFoodReport`,
      params: { Month, Year },
      headers: { EmployeeID: EmployeeID },
      data: filterData,
      responseType: "blob", // Important for downloading files
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.GetFoodSubsidyEmpdetails = async function (
  filterData,
  formattedMonth,
) {
  try {
    const response = await axios({
      method: "GET",
      url: `/EmployeeService.svc/GetFoodSubsidyEmpdetails`,
      params: { FoodOptedMonth: formattedMonth },
      headers: { EmployeeID: EmployeeID },
      data: filterData,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};
EmployeeService.subdepartmentlist = async function (DepartmentName) {
  try {
    const response = await axios({
      url: `/DepartmentService.svc/GetSubDepartmentByDepartmentID?Departmentname=${encodeURIComponent(DepartmentName)}`,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.AddSubDepartment = async function (EmployeeID, payload) {
  try {
    const response = await axios({
      method: "POST",
      url: `/DepartmentService.svc/AddSubDepartment`,
      headers: { EmployeeID: EmployeeID },
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.DeleteSubDepartment = async function (EmployeeID, payload) {
  try {
    const response = await axios({
      method: "DELETE",
      url: `/DepartmentService.svc/DeleteSubDepartmentById?SubDepartmentId=${payload}`,
      headers: { EmployeeID: EmployeeID },
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

EmployeeService.UpdateSubDepartment = async function (EmployeeID, payload) {
  try {
    const response = await axios({
      method: "POST",
      url: `/DepartmentService.svc/UpdateSubDepartment`,
      headers: { EmployeeID: EmployeeID },
      data: payload,
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};


EmployeeService.GetUserEngagementDashboard = async function (
  EmployeeID,
  Year,
  Month
) {
  try {
    const response = await axios({
      method: "GET",
      url: `/EmployeeService.svc/GetUserEngagementDashboard?Year=${Year}&Month=${Month}`,
      headers: {
        EmployeeID: EmployeeID,
      },
    });

    return response;
  } catch (error) {
    console.log("GetUserEngagementDashboard API Error:", error);
    return null;
  }
};


EmployeeService.GetUserEngagementPlatformEmployeeDashboard = async function (
  EmployeeID,
  Year,
  Month
) {
  try {
    const response = await axios({
      method: "GET",
      url: `/EmployeeService.svc/GetUserEngagementPlatformEmployeeDashboard?Year=${Year}&Month=${Month}`,
      headers: {
        EmployeeID: EmployeeID,
      },
    });

    return response;
  } catch (error) {
    console.log("GetUserEngagementPlatformEmployeeDashboard API Error:", error);
    return null;
  }
};


export default EmployeeService;
